module.exports = __webpack_public_path__ + "img/Nessie-Judge.ea3f4a93.png";